import React, { Component, useState, useMemo, useEffect } from 'react';

import { fetchData } from "../common/networkRequests";
import { createComponent } from "../FormArea/FormContent/index";
import './ModalStyle.css';
import { FaArrowDown, FaRegWindowRestore } from "react-icons/fa";

import { getObjectsValue, clearDisplayData, forceClearData, calculateInterest, padding, RelevantIcon } from '../oro-module/commonFunctions';
import AutoComponent from '../common/AutoComponent';


export const FlatFootersGenerator = (props) => {

  let [displayComponents, setdisplayComponents] = useState([]);
  let [isloading, setisloading] = useState(false);

  let { component } = props;
  let { components, pivot_fastpath, pivotat, hidden, foot, dynamicDescription, otherData } = component;
  let reference = pivotat.replace('_code', '');
  let x;
  !dynamicDescription ? dynamicDescription = "description" : x = 1;
  let code_name = reference + "_code";
  let display_name = reference + "_display";
  let uid_name = reference + "_uid";


  const setchecklistFromOutside = (response) => {
    let newChecklist = [];
    response.results.map((res, idx) => {

      if (res[reference + "_active"]) {
        let newname_code = foot + '[' + idx + '][' + code_name + ']';
        let newname_display = foot + '[' + idx + '][' + display_name + ']';
        let newname_uid = foot + '[' + idx + '][' + uid_name + ']';

        let code_value = res[code_name];
        let display_value = res[display_name];
        let uid_value = res[uid_name];

        newChecklist.push({ description: res[dynamicDescription] });
        props.liftState({ name: newname_code }, code_value);
        props.liftState({ name: newname_display }, display_value);
        props.liftState({ name: newname_uid }, uid_value);
      }
    });
    // setchecklist(newChecklist);

    let allComponents = [];
    newChecklist.map(({ description }, idx1) => {
      let componentGroup = [];

      components.map((c, idx2) => {
        let newcomp = JSON.parse(JSON.stringify(c));
        let fieldname = newcomp.name;

        if (newcomp.name) {
          let x = foot + '[' + idx1 + '][' + newcomp.name + ']';
          newcomp.name = x;
        } else if (newcomp.data) {
          let x = foot + '[' + idx1 + '][' + newcomp.data + ']';
          newcomp.data = x;
        }
        let ndd = {};

        if (newcomp.inputType == 'modalinput') {
          ndd[fieldname.replace('_code', '_uid')] = newcomp.name.replace('_code', '_uid');
          for (var key in newcomp.displayData) {
            ndd[key] = foot + '[' + idx1 + '][' + newcomp.displayData[key] + ']';
          }
        }


        newcomp.displayData = ndd;

        if (newcomp.parents) {
          let p = [];
          newcomp.parents.map(cp => {
            // BUG: If a parent is outside of this footers, then the following wont work.
            p.push({ ...cp, name: foot + '[' + idx1 + '][' + cp.name + ']' })
          })
          newcomp.parents = p;
        }
        if (newcomp.dynamicDescription) {
          // console.log({ description })
          newcomp.description = description;
        }


        if (newcomp.target) {
          newcomp.labelShortcuts = false;
        }

        componentGroup.push(newcomp);
      })
      let subc =
      {
        widths: "col-sm-12",
        tab: foot,
        title: String(idx1 + 1),
        titleStyle: { position: "left", size: 20 },
        subComponents: componentGroup
      };
      allComponents.push(subc);
    })
    setdisplayComponents(allComponents);
    setisloading(false);

  }

  const getPivotValues = () => {
    let saveThis = { dataType: 'search', currentPage: pivot_fastpath, showAll: true };

    if (otherData) {
      saveThis['pageData'] = {};
      for (var key in otherData) {
        if (otherData[key].source == 'appWrapper') {
          let val = props.parentProps.parentState[otherData[key]['field']]
          saveThis['pageData'][key] = val;
        }
      }
    }
    // fetch the values for autocomplete control to speed up the loading later.
    setisloading(true);
    console.log({ saveThis })
    fetchData({ url: 'cbsurl', postData: saveThis, current: { props }, cbf: setchecklistFromOutside });
  }



  useEffect(() => getPivotValues(), []);

  return (
    <div className={`form-group col-sm-12`} style={{ display: hidden ? "none" : "block" }}>
      {isloading &&
        <div>Loading ...</div>
      }
      {!isloading &&
        <div className="row">
          {createComponent({
            allc: displayComponents,
            current: { props }
          })}
        </div>
      }
    </div>

  )
}